// import React, { useEffect, useState } from "react";
// import NewsCol from "../../components/organisms/news/NewsCol";
// import NewsDeep from "../../components/organisms/news/NewsDeep";
// import NewsLatest from "../../components/organisms/news/NewsLatest";
// import { useAppSelector } from "../../redux/ReduxType";
// import { NEWS_API } from "../../constant/resource";
// import axios from "axios";
// import {
//   businessNews,
//   entertainmentNews,
//   featuredNews,
//   getLatestNews,
//   getPopularNews,
//   getTrendingNews,
//   handleTitleClick,
//   politicalNews,
//   technologyNews,
// } from "./data";
// import { timeAgo } from "../../utils/day.format";
// import CustomLoader from "../../components/shared/PageLoader";

// interface INews {}

// const News: React.FC<INews> = () => {
//   const [news, setNews] = useState<any>(null);
//   const [option, setOption] = useState("trend");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     setLoading(true);
//     const fetchNews = async () => {
//       try {
//         const response = await axios.get(NEWS_API + "api/posts/published");
//         setNews(response?.data?.data?.posts);
//       } catch (error) {
//         console.error("Error fetching news:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchNews();
//   }, []);

//   const handleSelection = (selectedValue: string) => {
//     setOption(selectedValue);
//   };
//   const isDark = useAppSelector((state) => state.theme.isDark);
//   if (loading) {
//     return (
//       <div className="flex justify-center items-center min-h-screen">
//         <CustomLoader
//           type="splitter"
//           color={isDark ? "#ffffff" : "#0000ff"}
//           size={80}
//         />
//       </div>
//     );
//   }
//   return (
//     <div
//       className={`rounded-lg my-2 ${
//         isDark ? "text-darkText" : " text-deepBg"
//       } custom-scrollbar`}
//     >
//       <div className="sm:flex sm:items-start sm:justify-center gap-5">
//         {news ? (
//           <div className="sm:w-2/3 w-full h-[400px] relative after:absolute after:top-0 after:left-0 after:w-full after:h-full after:bg-gradient-to-b after:from-transparent after:to-black">
//             <img
//               className="h-full object-cover"
//               src={news[0]?.featured_image}
//               alt="politics"
//             />
//             <div className="text-white z-30 absolute bottom-10 left-10">
//               <h2 className="text-sm">
//                 {news[0]?.category_names} / {timeAgo(news[0]?.created_at)}
//               </h2>
//               <h1 className="text-3xl font-semibold">{news[0]?.meta_title}</h1>
//               <p className="sm">{news[0]?.meta_description}</p>
//             </div>
//           </div>
//         ) : null}

//         {/* left side panel */}
//         <div className="sm:w-1/3 w-full overflow-hidden sm:mt-0 mt-5">
//           {/* category selection */}
//           <div className="flex items-center sm:justify-between justify-center gap-2 text-sm">
//             <span
//               onClick={() => {
//                 handleSelection("trend");
//               }}
//               className={`${
//                 isDark
//                   ? "bg-darkBg hover:bg-indigo-400"
//                   : "bg-white text-deepBg hover:text-gray-400"
//               } px-3 py-[4px] cursor-pointer`}
//             >
//               Trendy
//             </span>
//             <span
//               onClick={() => {
//                 handleSelection("latest");
//               }}
//               className={`${
//                 isDark
//                   ? "bg-darkBg hover:bg-indigo-400"
//                   : "bg-white text-deepBg hover:text-gray-400"
//               } px-3 py-[4px] cursor-pointer`}
//             >
//               Latest
//             </span>
//             <span
//               onClick={() => {
//                 handleSelection("popular");
//               }}
//               className={`${
//                 isDark
//                   ? "bg-darkBg hover:bg-indigo-400"
//                   : "bg-white text-deepBg hover:text-gray-400"
//               } px-3 py-[4px] cursor-pointer`}
//             >
//               Popular
//             </span>
//           </div>

//           {/* list of news */}
//           <div className="mt-5">
//             {option === "trend" && news?.length
//               ? getTrendingNews(news)?.map((eachNews: any) => {
//                   return (
//                     <div key={eachNews?.id}>
//                       <NewsCol
//                         newsImage={eachNews?.featured_image}
//                         isDark={isDark}
//                         date={String(timeAgo(eachNews?.created_at))}
//                         details={eachNews?.meta_title}
//                         category={eachNews?.category_names}
//                         click={() => {
//                           handleTitleClick(eachNews?.slug);
//                         }}
//                       />
//                     </div>
//                   );
//                 })
//               : null}

//             {option === "latest"
//               ? getLatestNews(news, 5)?.map((eachNews: any) => {
//                   return (
//                     <div key={eachNews?.id}>
//                       <NewsCol
//                         newsImage={eachNews?.featured_image}
//                         isDark={isDark}
//                         date={String(timeAgo(eachNews?.created_at))}
//                         details={eachNews?.meta_title}
//                         category={eachNews?.category_names}
//                         click={() => {
//                           handleTitleClick(eachNews?.slug);
//                         }}
//                       />
//                     </div>
//                   );
//                 })
//               : null}

//             {option === "popular"
//               ? getPopularNews(news)?.map((eachNews: any) => {
//                   return (
//                     <div key={eachNews?.id}>
//                       <NewsCol
//                         newsImage={eachNews?.featured_image}
//                         isDark={isDark}
//                         date={String(timeAgo(eachNews?.created_at))}
//                         details={eachNews?.meta_title}
//                         category={eachNews?.category_names}
//                         click={() => {
//                           handleTitleClick(eachNews?.slug);
//                         }}
//                       />
//                     </div>
//                   );
//                 })
//               : null}
//           </div>
//         </div>
//       </div>

//       {/* featured */}
//       <div className={`w-full mt-4 block`}>
//         <div className="w-full flex items-center justify-between py-10">
//           <h2 className="text-2xl">Featured</h2>
//         </div>

//         <div className="w-[full] h-[100px] flex items-center mt-4 gap-2">
//           {news?.length
//             ? featuredNews(news, 3)?.map((eachNews: any) => {
//                 return (
//                   <div>
//                     <NewsDeep
//                       title="Seashell and our environment"
//                       small={true}
//                       newsImage={eachNews?.featured_image}
//                       isDark={isDark}
//                       date={String(timeAgo(eachNews?.created_at))}
//                       details={eachNews?.meta_title}
//                       category={eachNews?.category_names}
//                     />
//                   </div>
//                 );
//               })
//             : null}
//         </div>
//       </div>

//       {/* latest news */}
//       <div className={`w-full mt-20 h-auto block`}>
//         <div className="w-full flex items-center justify-between mb-[4px]">
//           <h2 className="text-2xl">Latest</h2>
//         </div>
//         <div className="flex items-start justify-between w-full overflow-auto">
//           {news?.length
//             ? getLatestNews(news, 3)?.map((eachNews: any, index: number) => {
//                 return (
//                   <div className="min-w-[400px]" key={index}>
//                     <NewsLatest
//                       title={eachNews?.title}
//                       newsImage={eachNews?.featured_image}
//                       isDark={isDark}
//                       date={String(timeAgo(eachNews?.created_at))}
//                       details={eachNews?.meta_title}
//                       category={eachNews?.category_names}
//                     />
//                   </div>
//                 );
//               })
//             : null}
//         </div>
//       </div>

//       {/* others */}
//       <div className="mt-10">
//         <hr className={`w-full h-[2px] ${isDark ? "bg-darkBg" : "bg-black"}`} />
//       </div>

//       {/* other list */}
//       <div className="flex flex-wrap mt-4 ">
//         {technologyNews(news, 1)?.map((eachNews: any, index: number) => {
//           return (
//             <NewsCol
//               key={index}
//               newsImage={eachNews?.featured_image}
//               isDark={isDark}
//               date={String(timeAgo(eachNews?.created_at))}
//               details={eachNews?.meta_title}
//               category={eachNews?.category_names}
//               click={() => {
//                 handleTitleClick(eachNews?.slug);
//               }}
//             />
//           );
//         })}
//       </div>
//       <div className="flex flex-wrap mt-4 ">
//         {politicalNews(news, 1)?.map((eachNews: any, index: number) => {
//           return (
//             <NewsCol
//               key={index}
//               newsImage={eachNews?.featured_image}
//               isDark={isDark}
//               date={String(timeAgo(eachNews?.created_at))}
//               details={eachNews?.meta_title}
//               category={eachNews?.category_names}
//               click={() => {
//                 handleTitleClick(eachNews?.slug);
//               }}
//             />
//           );
//         })}
//       </div>
//       <div className="flex flex-wrap mt-4 ">
//         {businessNews(news, 1)?.map((eachNews: any, index: number) => {
//           return (
//             <NewsCol
//               key={index}
//               newsImage={eachNews?.featured_image}
//               isDark={isDark}
//               date={String(timeAgo(eachNews?.created_at))}
//               details={eachNews?.meta_title}
//               category={eachNews?.category_names}
//               click={() => {
//                 handleTitleClick(eachNews?.slug);
//               }}
//             />
//           );
//         })}
//       </div>
//       <div className="flex flex-wrap mt-4 ">
//         {entertainmentNews(news, 1)?.map((eachNews: any, index: number) => {
//           return (
//             <NewsCol
//               key={index}
//               newsImage={eachNews?.featured_image}
//               isDark={isDark}
//               date={String(timeAgo(eachNews?.created_at))}
//               details={eachNews?.meta_title}
//               category={eachNews?.category_names}
//               click={() => {
//                 handleTitleClick(eachNews?.slug);
//               }}
//             />
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default News;

// ------- version 2 ----------
import React, { useEffect, useState } from "react";
import NewsCol from "../../components/organisms/news/NewsCol";
import NewsDeep from "../../components/organisms/news/NewsDeep";
import NewsLatest from "../../components/organisms/news/NewsLatest";
import { useAppSelector } from "../../redux/ReduxType";
import { NEWS_API } from "../../constant/resource";
import axios from "axios";
import {
  businessNews,
  entertainmentNews,
  featuredNews,
  getLatestNews,
  getPopularNews,
  getTrendingNews,
  handleTitleClick,
  politicalNews,
  technologyNews,
} from "./data";
import { timeAgo } from "../../utils/day.format";
import CustomLoader from "../../components/shared/PageLoader";

interface INews {}

const News: React.FC<INews> = () => {
  const [news, setNews] = useState<any>(null);
  const [option, setOption] = useState("trend");
  const [loading, setLoading] = useState(false);
  const [firstNews, setFirstNews] = useState<any>(null);

  useEffect(() => {
    setLoading(true);
    const fetchNews = async () => {
      try {
        const response = await axios.get(NEWS_API + "api/posts/published");
        setNews(response?.data?.data?.posts);
        setFirstNews(response?.data?.data?.posts[0]);
      } catch (error) {
        console.error("Error fetching news:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  const handleSelection = (selectedValue: string) => {
    setOption(selectedValue);
  };
  const isDark = useAppSelector((state) => state.theme.isDark);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100 dark:bg-gray-900">
        <CustomLoader
          type="dash" // Updated to the new Material-style loader
          color={isDark ? "#ffffff" : "#3b82f6"}
          size={48}
        />
      </div>
    );
  }

  return (
    <div
      className={`min-h-screen my-2 py-6 px-4 ${
        isDark ? "text-white" : "text-gray-900"
      } custom-scrollbar`}
    >
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Hero Section */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-center gap-6">
          {news ? (
            <div className="sm:w-2/3 w-full h-[400px] rounded-lg overflow-hidden shadow-md relative bg-gray-200 dark:bg-gray-800">
              <img
                className="w-full h-full object-cover"
                src={firstNews?.featured_image}
                alt="Featured news"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <p className="text-sm text-gray-300">
                  {firstNews?.category_names} • {timeAgo(firstNews?.created_at)}
                </p>
                <h1
                  onClick={() => {
                    handleTitleClick(firstNews.slug);
                  }}
                  className="text-2xl cursor-pointer font-medium mt-1 truncate"
                >
                  {firstNews?.meta_title}
                </h1>
                <p className="text-sm mt-2 line-clamp-2">
                  {firstNews?.meta_description}
                </p>
              </div>
            </div>
          ) : null}

          {/* Category Sidebar */}
          <div className="sm:w-1/3 w-full space-y-4">
            <div
              className={`flex items-center overflow-auto justify-start gap-2 text-sm ${
                isDark ? "bg-darkBg" : "bg-white"
              } dark:bg-gray-800 rounded-md shadow-sm p-2`}
            >
              {["trend", "latest", "popular"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => handleSelection(tab)}
                  className={`px-3 py-1 rounded-md capitalize ${
                    option === tab
                      ? `${isDark ? "bg-darkBg" : "bg-gray-700"} text-white`
                      : isDark
                      ? "text-gray-300 hover:bg-gray-700"
                      : "text-gray-700 hover:bg-gray-100"
                  } transition-colors duration-200`}
                >
                  {tab === "trend" ? "Trendy" : tab}
                </button>
              ))}
            </div>

            <div className="space-y-4">
              {option === "trend" && news?.length
                ? getTrendingNews(news)?.map((eachNews: any) => (
                    <NewsCol
                      key={eachNews?.id}
                      newsImage={eachNews?.featured_image}
                      isDark={isDark}
                      date={String(timeAgo(eachNews?.created_at))}
                      details={eachNews?.meta_title}
                      category={eachNews?.category_names}
                      click={() => handleTitleClick(eachNews?.slug)}
                    />
                  ))
                : null}
              {option === "latest" && news?.length
                ? getLatestNews(news, 5)?.map((eachNews: any) => (
                    <NewsCol
                      key={eachNews?.id}
                      newsImage={eachNews?.featured_image}
                      isDark={isDark}
                      date={String(timeAgo(eachNews?.created_at))}
                      details={eachNews?.meta_title}
                      category={eachNews?.category_names}
                      click={() => handleTitleClick(eachNews?.slug)}
                    />
                  ))
                : null}
              {option === "popular" && news?.length
                ? getPopularNews(news)?.map((eachNews: any) => (
                    <NewsCol
                      key={eachNews?.id}
                      newsImage={eachNews?.featured_image}
                      isDark={isDark}
                      date={String(timeAgo(eachNews?.created_at))}
                      details={eachNews?.meta_title}
                      category={eachNews?.category_names}
                      click={() => handleTitleClick(eachNews?.slug)}
                    />
                  ))
                : null}
            </div>
          </div>
        </div>

        {/* Featured Section */}
        <section className="mt-8">
          <h2 className="text-xl font-medium mb-4">Featured</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {news?.length
              ? featuredNews(news, 3)?.map((eachNews: any) => (
                  <NewsDeep
                    key={eachNews?.id}
                    title={eachNews?.meta_title} // Consider dynamic title
                    small={true}
                    newsImage={eachNews?.featured_image}
                    isDark={isDark}
                    slug={eachNews?.slug}
                    date={String(timeAgo(eachNews?.created_at))}
                    details={eachNews?.meta_title}
                    category={eachNews?.category_names}
                  />
                ))
              : null}
          </div>
        </section>

        {/* Latest News Section */}
        <section className="mt-8">
          <h2 className="text-xl font-medium mb-4">Latest</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {news?.length
              ? getLatestNews(news, 3)?.map((eachNews: any, index: number) => (
                  <NewsLatest
                    key={index}
                    slug={eachNews.slug}
                    title={eachNews?.title}
                    newsImage={eachNews?.featured_image}
                    isDark={isDark}
                    date={String(timeAgo(eachNews?.created_at))}
                    details={eachNews?.meta_title}
                    category={eachNews?.category_names}
                  />
                ))
              : null}
          </div>
        </section>

        {/* Divider */}
        <hr className="my-8 border-t border-gray-300 dark:border-gray-700" />

        {/* Other Categories */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[technologyNews, politicalNews, businessNews, entertainmentNews].map(
            (categoryFn, idx) => (
              <div key={idx}>
                {categoryFn(news, 1)?.map((eachNews: any) => (
                  <NewsCol
                    key={eachNews?.id}
                    newsImage={eachNews?.featured_image}
                    isDark={isDark}
                    date={String(timeAgo(eachNews?.created_at))}
                    details={eachNews?.meta_title}
                    category={eachNews?.category_names}
                    click={() => handleTitleClick(eachNews?.slug)}
                  />
                ))}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default News;
